/** React Router's monotonic history entry index, when present. */
export const getHistoryIdx = (): number | undefined => {
	const state = window.history.state as null | { idx?: unknown };
	return typeof state?.idx === "number" ? state.idx : undefined;
};

/**
 * React Router stores a monotonic `idx` on `history.state`. idx > 0 means this
 * tab has an in-app predecessor we can pop to.
 *
 * If `idx` is missing, do not guess from `history.length` — that predecessor
 * may be an external page (email link). Callers should use their fallback path.
 */
export const canPopInAppHistory = (): boolean => {
	const idx = getHistoryIdx();
	return idx !== undefined && idx > 0;
};
